import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { unreadChatList } from '../../redux/slice/UnreadChatList'
import PerfectScrollbar from 'react-perfect-scrollbar'
import moment from 'moment';
import { Button } from 'react-bootstrap'
import Loader from '../../components/loader/Loader'
import { FaComments } from 'react-icons/fa'
import ChatBox from './Chatbox'

export default function ChatList() {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [bool, setBool] = useState(false)
    const [selectedFollower, setSelectedFollower] = useState(null)
    const chatList = useSelector(state => state?.unreadChatList?.data)
    const [showChat, setShowChat] = useState(false)

    const formatDisplayDate = (date) => {
        if (!date) return ''
        const formattedDate = moment(date).locale('en').format('DD-MMM-YYYY')
        return formattedDate === 'Invalid date' ? '' : formattedDate
    }

    const handleChat = (user) => {
        setSelectedFollower(user)
        setShowChat(true)
    }

    const handleCloseChat = () => {
        dispatch(unreadChatList({ navigate }))
        setShowChat(false)
        setSelectedFollower(null)
    }

    useEffect(() => {
        setLoading(true)
        dispatch(unreadChatList({ navigate })).then((res) => list_res(res.payload))
    }, [bool])

    const list_res = (res) => {
        if (res?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    // Get initials for avatar
    const getInitials = (name) => {
        if (!name || name === 'undefined' || name === 'null') return 'U'
        // Trim and filter empty strings to handle trailing or double spaces
        const names = name.trim().split(' ').filter(n => n.length > 0)
        if (names.length >= 2) {
            return (names[0][0] + names[names.length - 1][0]).toUpperCase()
        }
        return name.trim().substring(0, 2).toUpperCase()
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout py-3 mb-2'>
                            <div className='d-flex justify-content-between align-items-center flex-wrap gap-2'>
                                <h5 className="mb-0 fw-bold">Chat List</h5>
                                <div className="text-muted d-flex align-items-center" style={{ fontSize: '13px', background: '#f0f4f8', padding: '6px 15px', borderRadius: '30px' }}>
                                    <i className="bi bi-info-circle-fill me-2 text-primary"></i>
                                    <span>If you want to block/unblock any user or start chat with any user go to <Link to="/connection-management" className="fw-bold text-primary text-decoration-none">Connection Management</Link></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ?
                        <div className="col-md-12 mt-3">
                            <div className="layout text-center">
                                <Loader />
                            </div>
                        </div> :
                        <div className='col-md-12 mt-0'>
                            <div className="layout p-0 bg-transparent shadow-none">
                                <PerfectScrollbar
                                    style={{
                                        overflow: 'auto',
                                        height: '75vh',
                                        position: 'relative',
                                        paddingRight: '10px'
                                    }}
                                    options={{ suppressScrollX: true }}
                                >
                                    {chatList && chatList.length > 0 ? (
                                        chatList.map((chat, index) => {
                                            const userDetails = chat?.user
                                            const profileDetail = userDetails?.profile
                                            const profilePhoto = profileDetail?.profile_photo || userDetails?.profile_photo
                                            
                                            // Handle potential 'undefined' strings and trailing spaces
                                            const rawTitle = profileDetail?.title || userDetails?.name
                                            const rawName = userDetails?.name
                                            
                                            const validTitle = (rawTitle && rawTitle !== 'undefined' && rawTitle !== 'null') ? rawTitle : null
                                            const validName = (rawName && rawName !== 'undefined' && rawName !== 'null') ? rawName : null
                                            
                                            const name = (validTitle || validName || 'User').trim()
                                            const userName = userDetails?.user_name

                                            return (
                                                <div key={chat?.id || index} className="card mb-3 border-0 shadow-sm hover-card" style={{ borderRadius: '12px', transition: 'all 0.3s ease', cursor: 'pointer' }}>
                                                    <div className="card-body p-3">
                                                        <div className="d-flex align-items-center">
                                                            {/* Avatar Section */}
                                                            <div className="flex-shrink-0 me-3 position-relative">
                                                                {profilePhoto ? (
                                                                    <img
                                                                        src={profilePhoto.startsWith('http') ? profilePhoto : `${process.env.REACT_APP_BASE_URL}${profilePhoto}`}
                                                                        alt={name}
                                                                        className="rounded-circle object-fit-cover"
                                                                        style={{ width: '50px', height: '50px', border: '2px solid #eee' }}
                                                                        onError={(e) => {
                                                                            e.target.style.display = 'none';
                                                                            e.target.nextSibling.style.display = 'flex';
                                                                        }}
                                                                    />
                                                                ) : null}
                                                                <div
                                                                    className="rounded-circle align-items-center justify-content-center text-white fw-bold"
                                                                    style={{
                                                                        width: '50px',
                                                                        height: '50px',
                                                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                                        fontSize: '18px',
                                                                        display: profilePhoto ? 'none' : 'flex',
                                                                        border: '2px solid #fff',
                                                                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    {getInitials(name)}
                                                                </div>
                                                            </div>

                                                            {/* Content Section */}
                                                            <div className="flex-grow-1 overflow-hidden">
                                                                <div className="d-flex flex-wrap justify-content-between align-items-center mb-1 gap-1">
                                                                    <h6 className="mb-0 fw-bold text-secondary text-truncate" style={{ fontSize: '16px', maxWidth: '100%' }}>
                                                                        {name}
                                                                    </h6>
                                                                    <Button
                                                                        variant="primary"
                                                                        className="follower-chat-list-btn py-1 px-3 d-flex justify-content-center align-items-center"
                                                                        style={{ fontSize: '14px', borderRadius: '8px' }}
                                                                        onClick={() => handleChat(chat)}
                                                                    >
                                                                        <FaComments className="me-2" />
                                                                        Chat
                                                                        {chat?.unreadCount > 0 && (<span className="badge bg-warning text-black ms-1 rounded-pill shadow-sm" style={{ fontSize: '10px', minWidth: '20px' }}>
                                                                            {chat?.unreadCount}
                                                                        </span>)}
                                                                    </Button>
                                                                    {/*  */}
                                                                </div>

                                                                <div className="d-flex flex-row justify-content-between align-items-center mt-1 gap-3 flex-nowrap w-100">
                                                                    {/* <p className="mb-0 text-dark flex-grow-1" style={{
                                                                        fontSize: '14px',
                                                                        fontWeight: '400',
                                                                        minWidth: 0,
                                                                        wordBreak: 'break-word',
                                                                        whiteSpace: 'normal',
                                                                        display: '-webkit-box',
                                                                        WebkitLineClamp: '2',
                                                                        WebkitBoxOrient: 'vertical',
                                                                        overflow: 'hidden'
                                                                    }}>
                                                                        {chat?.lastMessage?.message}
                                                                       
                                                                    </p> */}

                                                                    <p className="mb-0 text-muted small text-truncate fw-light">
                                                                        @{userName}
                                                                    </p>
                                                                    <small className="text-muted fw-medium text-nowrap" style={{ fontSize: '12px' }}>
                                                                        {chat?.lastMessage?.date && formatDisplayDate(chat.lastMessage.date)} : {chat?.lastMessage?.time && moment(chat.lastMessage.time, "HH:mm:ss").format('hh:mm A')}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : (
                                        <div className="text-center p-5 bg-white rounded-3 shadow-sm">
                                            <div className="mb-3 text-muted" style={{ fontSize: '40px' }}>💬</div>
                                            <h6 className="text-muted fw-bold">No conversations yet</h6>
                                            <p className="text-muted small">Start chatting to see your messages here.</p>
                                        </div>
                                    )}
                                </PerfectScrollbar>
                            </div>
                        </div>}
                </div >
            </div >
            <style jsx="true">{`
                .hover-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
                }
            `}</style>

            < ChatBox
                show={showChat}
                onHide={handleCloseChat}
                follower={selectedFollower}
            // fetchMessages={fetchMessages}
            // sendMessage={sendMessage}
            />
        </>
    )
}
